export default {
  en: {
    snack: {
      copied: 'Copied',
    },
    aria: {
      copy_input: 'Copy box',
      copy_button: 'Copy',
    },
  },
};
